import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Impersonate: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.083 6.083a2.917 2.917 0 105.834 0 2.917 2.917 0 00-5.834 0zm4.167 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.512 3.459L9 .622.49 3.459l2.79 10.228L9 17.502l5.722-3.815 2.79-10.228zm-15 1.082L9 2.378l6.489 2.163-1.853 6.795a2.918 2.918 0 00-2.552-1.503H6.917c-1.088 0-2.051.6-2.552 1.503L2.512 4.541zM5.67 13.28L9 15.499l3.329-2.22a34.647 34.647 0 00-.02-.77 1.25 1.25 0 00-1.226-1.009H6.917c-.6 0-1.112.426-1.227 1.006-.003.016-.014.444-.02.773z"
        fill={color}
      />
    </svg>
  );
};

export default Impersonate;
